import React, { useContext, useState } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'




import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'
import TimeModal from '../../comonents/TimeModal';
import PopUpModal from '../../comonents/PopUpModal';
export default function Game2MerkleTreeInfo() {

    const navigate = useNavigate();

    const { userInfo, privateID } = useContext(Context);
    const [showMSG, setShowMSG] = useState(false)
    function setMSG() {
        setShowMSG(true)
    }
    return (
        <div>
            <TitleBar backLastPage="" lastPageName="" />
            <div className='text-center'>
                <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>What is Merkle Tree?</p></b>
            </div>
            <div className='MerkleInformation fs-4'  >
                A Merkle tree is a <a href="#" >hash-based data structure</a> that is a generalization of the <a href="#" > hash list</a>. It is a  <a href="#" >tree</a> structure in which each leaf node is a hash of a block of data, and each non-leaf node is a hash of its children.
            </div>

            <div className='Btns_Back'>
                <input type="button" className='Btn_Back' value='Next' onClick={e => setMSG()} />
            </div>
            <PopUpModal setShowMSG={setShowMSG} showMSG={showMSG} MSGContext={"i dont knowsdfasdfhjkdshf dsafjsdfhdaklghsafdsklafhdsjfh dsajhkfjdskhfjkdshfkjdshflkhdsafhadsjfh sdhfskjd"} MSGTitle={"ohhh"} MSGBtn={"Back"} Link={"/scenario"} />
        </div>

    )
}